import './LoginView.scss'

import React, { useRef, useState } from 'react'

import Button from '../components/Button/Button'
import { Form } from '../components/Form/Form'
import { ReactComponent as RefereePro } from '../icons/general/refereepro.svg'
import TextField from '../components/TextField/TextField'
import { post } from '../helpers/request'
import t from '../helpers/i18n'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'

const emailValidation = (text) => /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(text) ? false : t('validations.invalid_email')
const passwordValidation = (text) => text.length >= 6 ? false : t('validations.password_min_length', 6)

const LoginView = ({ history }) => {
  const [formValid, setFormValid] = useState(false)
  const loginData = useRef()
  const [error, setError] = useState()
  const dispatch = useDispatch()

  const handleLogin = () => {
    setError(false)
    post('/login', loginData.current).then(response => {
      dispatch({ type: 'set-profile', profile: response.profile })
      history.push('/')
    }).catch(error => {
      if (error.code === 'NOT_AUTHENTICATED') {
        setError(t('validations.email_or_password_invalid'))
      } else if (error.code === 'VALIDATION_FAILURE') {
        setError(t('validations.review_fields_are_correct'))
      } else {
        setError(t('validations.unknow_error'))
      }
    })
  }

  return (
    <div className="login-view">
      <div className="-logo"><RefereePro /></div>
      <div className="-intro heading-tiny-basic">Ingresa tus datos para vivir la experiencia de RefereePro®. <span role="img" aria-label="football">⚽️</span></div>
      <div className="-title heading-tiny-bold">{t('titles.System_access')}</div>
      <div className="-content">
        <Form data={loginData} onValidityChange={setFormValid}>
          <TextField
            name="email"
            label={t("labels.Email")}
            onValidation={emailValidation}
          />
          <TextField
            name="password"
            label={t("labels.Password")}
            password
            onValidation={passwordValidation}
          />
        </Form>
        {error && <div className="-error caption-default-basic">{error}</div>}
        <div className="-buttons">
          <Button
            label={t('buttons.Login')}
            type="dark"
            color="green"
            grow
            disabled={!formValid}
            onClick={handleLogin}
          />
        </div>

        {process.env.REACT_APP_SHOW_REGISTER &&
          <>
            <div className="-guest">
              <div className="-text caption-small-basic">{t('labels.You_do_not_have_an_account')}</div>
              <div className="-line" />
            </div>
            <div className="-buttons">
              <Button
                label={t('buttons.Create_account')}
                type="light"
                color="neutral"
                grow
                onClick={() => history.push('/signup')}
              />
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default withRouter(LoginView)
